import { NgModule } from '@angular/core';
import {
  CommonModule,
  CurrencyPipe,
  DatePipe,
  TitleCasePipe
} from '@angular/common';
import { GridCellFormatterPipe } from './grid-cell-formatter.pipe';
import { ShortDatePipe, LongDatePipe } from './date/date.pipe';
import { HccCurrencyPipe } from './currency.pipe';
import { FormatNumberPipe } from './phone.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    GridCellFormatterPipe,
    ShortDatePipe,
    LongDatePipe,
    HccCurrencyPipe,
    FormatNumberPipe
  ],
  providers: [
    CurrencyPipe,
    DatePipe,
    TitleCasePipe,
    GridCellFormatterPipe,
    ShortDatePipe,
    LongDatePipe,
    HccCurrencyPipe,
    FormatNumberPipe
  ],
  exports: [
    GridCellFormatterPipe,
    ShortDatePipe,
    LongDatePipe,
    HccCurrencyPipe,
    FormatNumberPipe
  ]
})
export class PipesModule {}
